import Vue from 'vue'
import App from './App.vue'
// import VueRouter from 'vue-router'
import "./plugins/bootstrap-vue";
import router from './router.js'



import "./plugins/open-iconic-master/font/css/open-iconic-bootstrap.css";
import "./plugins/open-iconic-master/font/css/open-iconic-foundation.css";
import "./plugins/open-iconic-master/font/css/open-iconic.css";

// function removeUnwantedParams() {
//     const url = new URL(window.location.href);
//     const unwantedParams = ['theme', 'lang']; // Список параметров для удаления
  
//     unwantedParams.forEach(param => url.searchParams.delete(param));
  
//     // Проверяем, изменился ли URL, и обновляем его без перезагрузки страницы
//     if (window.location.href !== url.toString()) {
//       window.history.replaceState({}, document.title, url.toString());
//     }
//   }
  
//   // Вызов функции при загрузке страницы
//   removeUnwantedParams();
// Vue.use(VueRouter)
function cleanUpURL() {
    // Получите текущий URL
    const url = new URL(window.location.href);
  
    // Очистите все параметры запроса
    url.search = '';
  
    // Обновите URL без перезагрузки страницы
    window.history.replaceState({}, document.title, url.toString());
  }
// Вызовите функцию очистки URL
cleanUpURL();
Vue.config.productionTip = false

new Vue({
    router,
    render: h => h(App),
}).$mount('#app')